import { SEOProps } from "./SEO";

export const defaultSEO: SEOProps = {
  title: "Version2 - Powerful add-ons to the services you love",
  description:
    "Version2 provides a collection of add-ons to services and tools you already use: extensions, themes, scripts, and other tools that rocket the services you already know and love to the next level.",
  keywords:
    "add-ons, extensions, productivity, airtable, plutio, automation, tools, version2, chrome extensions, browser extensions, workflow automation",
  image: "https://version2.io/favicon.png",
  url: "https://version2.io",
  type: "website",
  author: "Version2",
  twitterCard: "summary_large_image",
  siteName: "Version2",
};

export const pageSEO = {
  home: {
    title: "Version2 - Powerful add-ons to the services you love",
    description:
      "Discover powerful add-ons for Airtable, Plutio, and more. Version2 provides extensions, themes, scripts, and tools to enhance your favorite services and boost your productivity.",
    keywords:
      "version2, add-ons, extensions, productivity tools, airtable extensions, plutio extensions, browser extensions, automation tools, workflow enhancement",
    url: "https://version2.io",
  },
  explore: {
    title: "Explore Add-ons",
    description:
      "Browse our collection of powerful add-ons for Airtable, Plutio, and other popular services. Find extensions and tools to enhance your workflow and boost productivity.",
    keywords:
      "explore add-ons, browse extensions, airtable add-ons, plutio add-ons, productivity extensions, workflow tools, automation add-ons",
    url: "https://version2.io/explore",
  },
  pricing: {
    title: "Pricing",
    description:
      "Flexible pricing plans for Version2 add-ons. Choose the plan that works best for you with monthly or annual billing options. Start with free trials on select add-ons.",
    keywords:
      "pricing, plans, subscription, add-on pricing, extension pricing, free trial, monthly billing, annual billing, affordable add-ons",
    url: "https://version2.io/pricing",
  },
  about: {
    title: "About Us",
    description:
      "Learn about Version2 and our mission to create powerful add-ons that enhance the services you already love. Discover how we help teams and individuals work more efficiently.",
    keywords:
      "about version2, our mission, company information, team, add-on development, productivity solutions",
    url: "https://version2.io/about",
  },
  help: {
    title: "Help Center",
    description:
      "Get help with Version2 add-ons. Find guides, tutorials, FAQs, and support resources to make the most of your add-ons and troubleshoot any issues.",
    keywords:
      "help center, support, documentation, tutorials, guides, FAQs, troubleshooting, customer support",
    url: "https://version2.io/help-center",
  },
  docs: {
    title: "Documentation",
    description:
      "Complete documentation for Version2 add-ons. Learn how to install, configure, and use our extensions with detailed guides and API references.",
    keywords:
      "documentation, docs, guides, API reference, tutorials, installation guide, configuration, developer docs",
    url: "https://version2.io/docs",
  },
  signIn: {
    title: "Sign In",
    description:
      "Sign in to your Version2 account to manage your add-ons, subscriptions, and account settings. Access your dashboard and start using your extensions.",
    keywords: "sign in, login, account access, user authentication, dashboard access",
    url: "https://version2.io/sign-in",
  },
  signUp: {
    title: "Sign Up",
    description:
      "Create your free Version2 account to get started with powerful add-ons. Sign up now and enhance your favorite services with our extensions and tools.",
    keywords:
      "sign up, register, create account, new account, get started, free account",
    url: "https://version2.io/sign-up",
  },
  dashboard: {
    title: "Dashboard",
    description:
      "Manage your Version2 add-ons, view your subscriptions, and configure your account settings from your personal dashboard.",
    keywords: "dashboard, account management, my add-ons, subscriptions, user settings",
    url: "https://version2.io/dashboard",
  },
  dashboardAddOns: {
    title: "My Add-ons",
    description:
      "View and manage all your installed Version2 add-ons. Access settings, updates, and usage information for each extension.",
    keywords: "my add-ons, installed extensions, manage add-ons, extension settings",
    url: "https://version2.io/dashboard/add-ons",
  },
  dashboardAccount: {
    title: "Account Settings",
    description:
      "Manage your Version2 account settings, update your profile, change password, and configure preferences.",
    keywords: "account settings, profile settings, user preferences, account management",
    url: "https://version2.io/dashboard/account",
  },
  dashboardBilling: {
    title: "Billing & Subscriptions",
    description:
      "Manage your Version2 subscriptions, view billing history, update payment methods, and handle invoices.",
    keywords: "billing, subscriptions, payment, invoices, payment methods, subscription management",
    url: "https://version2.io/dashboard/billing",
  },
  oauth: {
    title: "Authorize Application",
    description:
      "Authorize an application to access your Version2 account securely using OAuth 2.0.",
    keywords: "oauth, authorization, security, authentication, oauth2",
    url: "https://version2.io/oauth/authorize",
  },
  termsOfService: {
    title: "Terms of Service",
    description:
      "Read Version2's Terms of Service. Learn about the legal terms and conditions for using our add-ons and services.",
    keywords: "terms of service, terms and conditions, legal terms, user agreement",
    url: "https://version2.io/terms-of-service",
  },
  privacyPolicy: {
    title: "Privacy Policy",
    description:
      "Version2's Privacy Policy explains how we collect, use, and protect your personal information. Your privacy is important to us.",
    keywords: "privacy policy, data protection, personal information, privacy rights, GDPR",
    url: "https://version2.io/privacy-policy",
  },
  refundPolicy: {
    title: "Refund Policy",
    description:
      "Learn about Version2's refund policy. Understand our terms for refunds, cancellations, and money-back guarantees.",
    keywords: "refund policy, money back guarantee, cancellation policy, refunds",
    url: "https://version2.io/refund-policy",
  },
  suggestions: {
    title: "Suggest an Add-on",
    description:
      "Have an idea for a new add-on? Share your suggestions with us. We value your feedback and love hearing about features you'd like to see.",
    keywords: "suggest add-on, feature request, feedback, ideas, new features",
    url: "https://version2.io/forms/add-on-suggestions",
  },
  bugReport: {
    title: "Report a Bug",
    description:
      "Found a bug or issue with a Version2 add-on? Report it here so we can fix it quickly and improve your experience.",
    keywords: "bug report, report issue, technical support, problem reporting",
    url: "https://version2.io/forms/bug-report",
  },
};
